var b2ControllerEdge = /** @class */ (function () {
    function b2ControllerEdge() {
    }
    return b2ControllerEdge;
}());
export { b2ControllerEdge };
